module.exports = __webpack_public_path__ + "img/collection-engagementRingsWhitegold.8a0416e.webp";